import { Component, Input } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FileUploadService } from '../../services/file-upload.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  selectedFiles: File[] = [];
  downloadURLs: any[] = [];
  uploadProgress: { fileName: string; percentage: number }[] = [];
  isHovering: boolean = false;
  isUploading: boolean = false;
  allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];
  maxFileSize = 5 * 1024 * 1024; // 5 MB
  @Input() filePath!: string;

  constructor(private fileUploadService: FileUploadService) {}

  // Handle file selection via input
  onFileSelected(event: any): void {
    const files: FileList = event.target.files;
    this.addFiles(files);
  }

  // Handle files dropped via drag-and-drop
  onDrop(event: CdkDragDrop<File[]>): void {
    const files = event.item.data;
    this.addFiles(files);
  }

  // Add files to the selectedFiles array with validation
  addFiles(files: FileList | File[]): void {
    for (let file of Array.from(files)) {
      if (!this.allowedTypes.includes(file.type)) {
        alert(`File type not allowed: ${file.name}`);
        continue;
      }
      if (file.size > this.maxFileSize) {
        alert(`File is too large (max 5 MB): ${file.name}`);
        continue;
      }
      this.selectedFiles.push(file);
    }
  }

  // Handle drag over event to add styling
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isHovering = true;
  }

  // Handle drag leave event to remove styling
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isHovering = false;
  }

  // Upload all selected files
  uploadFiles(): void {
    if (this.selectedFiles.length === 0) return;

    this.isUploading = true;
    this.uploadProgress = [];

    this.selectedFiles.forEach((file) => {
      this.fileUploadService.uploadFile(file, this.filePath).subscribe(
        (data) => {
          if (data.url) {
            this.downloadURLs.push({ url: data.url, fileName: file.name });
          }
          this.uploadProgress = this.uploadProgress.map((progress) => {
            if (progress.fileName === file.name) {
              return { fileName: file.name, percentage: data.progress };
            }
            return progress;
          });
        },
        (error) => {
          console.error('Error uploading file:', error);
        },
        () => {
          // Check if all uploads are complete
          if (this.uploadProgress.every((p) => p.percentage === 100)) {
            this.isUploading = false;
            this.selectedFiles = [];
          }
        }
      );

      // Initialize progress for the file
      this.uploadProgress.push({ fileName: file.name, percentage: 0 });
    });
  }
}
